import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import SlideItem from './Slide/SlideItem'

function NextArrow(props) {
  const { style, onClick } = props
  return (
    <div
      className="btn-next"
      style={{ ...style }}
      onClick={onClick}
    />
  )
}

function PrevArrow(props) {
  const { style, onClick } = props
  return (
    <div
      className="btn-prev"
      style={{ ...style }}
      onClick={onClick}
    />
  )
}


export default class HotelSlider extends React.PureComponent {
  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.any).isRequired,
  }

  render() {
    const {
      results,
      openFancyBox,
      openGalleryPopup,
    } = this.props

    const sliderSettings = {
      lazyLoad: 'anticipated',
      arrows: true,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      infinite: true,
      variableWidth: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerPadding: '0',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            variableWidth: false,
            slidesToShow: 1,
          },
        },
      ],
    }

    return (
      <Slider {...sliderSettings} className="hotel-intro-slider" ref={(slider) => { this.slider = slider }}>
        {results && results.map((item, key) => (
          <SlideItem
            fancyboxIndex={key}
            key={key}
            item={item}
            openFancyBox={openFancyBox}
            openGalleryPopup={openGalleryPopup}
          />
        ))}
      </Slider>
    )
  }
}
